import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../../assets/Icons";
import PrivateTxnViewAll from "../../PrivateTxnViewAll";

const PrivateViewAllPopup = ({
  onClose,
  currentCat,
  type,
  setOpenTransHistory,
  setInitialstage,
  setShowDetails,
  setShowLabel,
  setShowAdditionalDetails,
  openTransHistory,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => dispatch(enableSwitcher());
  }, []);

  return (
    <LargePopupRedirect
      headerTitle="Transaction history"
      headerFontWeight="semibold"
      headerFontColor="text-primary"
      headersubtext="All transactions related to the beneficiary are listed below"
      headertextSize="font-md"
      isfullViewrequired={true}
      fullviewbtnText="Open in full view"
      fullviewbtnType="button"
      fullviewhandleFunction={() => {
        onClose();
        navigate(`/private_transaction_dashboard/private_transaction_view_all`);
      }}
      fullviewisDisabled={false}
      fullviewenabledTextColor="var(--text-primary)"
      fullviewenabledBgColor="var(--primary-nav)"
      fullviewdisabledBgColor="var(--text-disabled)"
      fullviewhoverOption="white"
      fullviewicon={ICONS?.REDIRECT}
      closeiconbtnType="button"
      closeiconhandleFunction={onClose}
      closeiconisDisabled={false}
      closeiconenabledBgColor="var(--primary-nav)"
      closeicondisabledBgColor="var(--text-disabled)"
      closeiconhoverOption="white"
      closeicon={ICONS?.CLOSE}
      isbottomSectionneed={false}
      bottomHeaderTextNeed={false}
      // isscrollRequired={true}
    >
      <PrivateTxnViewAll
        onClose={onClose}
        type={type}
        currentCat={currentCat}
        setOpenTransHistory={setOpenTransHistory}
        setInitialstage={setInitialstage}
        setShowDetails={setShowDetails}
        setShowLabel={setShowLabel}
        setShowAdditionalDetails={setShowAdditionalDetails}
        openTransHistory={openTransHistory}
      />
    </LargePopupRedirect>
  );
};

export default PrivateViewAllPopup;
